import React, { useContext, useEffect, useRef } from "react";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import NoData from "../../../global/components/alerts/NoData";

export const jitsiTypes = {
  normal: "normal",
  noRecips: "noRecips",
};

export const JitsiLive = () => {
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { videoConference_state } = states ?? {};
  const { jitsiConfig } = videoConference_state ?? {};

  try {
    return jitsiConfig ? <Jitsi jitsiConfig={jitsiConfig} /> : <NoData altCaption={"Pending"} />;
  } catch (error) {
    return <div>{error.message || error.toString()}</div>;
  }
};

const Jitsi = ({ jitsiConfig }) => {
  const { roomName, displayName, password } = jitsiConfig ?? {};
  const containerRef = useRef(null);

  useEffect(() => {
    if (!roomName) return;

    const domain = "meet.jit.si";
    const options = {
      roomName,
      parentNode: containerRef.current,
      width: "100%",
      height: 600,
      userInfo: {
        displayName,
      },
      configOverwrite: {},
      interfaceConfigOverwrite: {},
    };

    // If you need password-protected rooms, set it after API init
    // (requires Jitsi server configured for password)
    // @ts-ignore
    const api = new window.JitsiMeetExternalAPI(domain, options);

    if (password) {
      api.addEventListener("videoConferenceJoined", () => {
        api.executeCommand("password", password);
      });
    }

    api.addEventListener("readyToClose", () => console.log("Meeting has ended"));

    return () => api?.dispose();
  }, [roomName, displayName, password]);

  return <div className="jitsi-wrapper" ref={containerRef} />;
};
